import { apiFetch } from './api';
import { clearAuthSession } from '../utils/authSession';

export async function login(email, password) {
  const res = await apiFetch('/api/auth/login', {
    method: 'POST',
    auth: false,
    body: { email, password }
  });
  try {
    localStorage.setItem('auth_token', res.token);
    localStorage.setItem('auth_user', JSON.stringify(res.user));
  } catch (_) {}
  return res;
}

export function logout() {
  clearAuthSession();
}

export function getCurrentUser() {
  try {
    const raw = localStorage.getItem('auth_user');
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}





